import { Injectable } from '@angular/core';
import { select } from '@ngneat/elf';
import { clarificationStateStore, ClarificationStateProps, clarificationInitialState } from './clarification-request-state.store';
import { BaseStoreRepository } from '../base-store.repository';
import { QuestionTask, QuestionValidationRequest, AdditifGroup, DemandeReportsResponse } from '@/types';

@Injectable({
  providedIn: 'root',
})
export class ClarificationRepository extends BaseStoreRepository<ClarificationStateProps> {
  constructor() {
    super(clarificationStateStore.pipe(select(state => state)), clarificationStateStore, clarificationInitialState);
  }

  setDemandeReports(demandeReports: DemandeReportsResponse) {
    this.set('demandeReports', demandeReports);
  }

  getDemandeReports(): DemandeReportsResponse | null {
    return this.get<DemandeReportsResponse | null>('demandeReports');
  }

  setResponseAndDto(response: QuestionTask | AdditifGroup) {
    this.set('response', response);
    // Only set dto for QuestionTask (not for AdditifGroup)
    if ('taskId' in response) {
      this.set('dto', {
        validate: true,
        answer: response.answer || '',
        typeQuestion: response.typeQuestion || 'SIMPLE',
      });
      this.set('initialDto', structuredClone(this.get('dto')));
    }
  }

  getResponse(): QuestionTask | AdditifGroup | null {
    return this.get<QuestionTask | AdditifGroup | null>('response');
  }

  getQuestionTask(): QuestionTask | null {
    const response = this.getResponse();
    return response && 'taskId' in response ? response : null;
  }

  getAdditifGroup(): AdditifGroup | null {
    const response = this.getResponse();
    // Check for referenceAdditif which is unique to AdditifGroup (not in QuestionTask)
    return response && 'referenceAdditif' in response ? (response as AdditifGroup) : null;
  }

  getValidationPayload(): QuestionValidationRequest {
    const dto = this.get<Partial<QuestionValidationRequest> | undefined>('dto');
    return {
      validate: dto?.validate ?? true,
      answer: dto?.answer ?? '',
      typeQuestion: (dto?.typeQuestion ?? 'SIMPLE') as 'SIMPLE' | 'ADDITIVE',
      haveReport:dto?.haveReport??false,
      dateReport: dto?.dateReport ?? null,
    };
  }
}
